module.exports = __webpack_public_path__ + "static/Q3Answer3_Salad_JezTimms-de7ea7ed69aef44505590783faa7920f.jpg";